import { useEffect } from "react";
import NetworkHelper from "../network/helpers/network/helper/NetworkHelper";
import { useDispatch, useSelector } from "react-redux";
import { SNACKBAR_VARIANTS } from "../constants";
import { RootState } from "../../redux/store";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { ComponentWithChildren } from "../types";
import { setOffline } from "../../redux/metadata/slice/metadataSlice";

let firstRender = true;

export const ConnectionChecker: ComponentWithChildren = ({ children }) => {
  const dispatch = useDispatch();
  const offline = useSelector((state: RootState) => state.metadata.offline);
  const { t } = useTranslation("common");
  const { enqueueSnackbar } = useSnackbar();

  const triggerSnackbar = () => {
    const message = t(`common.networkStatus.${offline ? "offline" : "online"}`);
    const variant = offline ? SNACKBAR_VARIANTS.warning : SNACKBAR_VARIANTS.success;
    enqueueSnackbar(<b>{message}</b>, { ...variant, autoHideDuration: 10000, disableWindowBlurListener: true });
  };

  const handleConnection = async (options: { mountRender: boolean }) => {
    firstRender = options.mountRender;
    const isOnline = await NetworkHelper.isConnected();
    dispatch(setOffline(!isOnline));
  };

  useEffect(() => {
    handleConnection({ mountRender: true });
  }, []);

  useEffect(() => {
    const options = { mountRender: false };
    window.addEventListener("online", () => handleConnection(options));
    window.addEventListener("offline", () => handleConnection(options));

    return () => {
      window.removeEventListener("online", () => handleConnection(options));
      window.removeEventListener("offline", () => handleConnection(options));
    };
  }, []);

  useEffect(() => {
    if (!firstRender) {
      triggerSnackbar();
    }
  }, [offline]);

  return <>{children}</>;
};
